__turbopack_context__.v({
  "content": "Dialog-module__IssQ8q__content",
  "contentPadding": "Dialog-module__IssQ8q__contentPadding",
  "dialog": "Dialog-module__IssQ8q__dialog",
  "dialogPadding": "Dialog-module__IssQ8q__dialogPadding",
  "header": "Dialog-module__IssQ8q__header",
  "headerContent": "Dialog-module__IssQ8q__headerContent",
  "headerPadding": "Dialog-module__IssQ8q__headerPadding",
  "modal": "Dialog-module__IssQ8q__modal",
  "noBorder": "Dialog-module__IssQ8q__noBorder",
  "notification": "Dialog-module__IssQ8q__notification",
  "overlay": "Dialog-module__IssQ8q__overlay",
  "popup": "Dialog-module__IssQ8q__popup",
  "scrollable": "Dialog-module__IssQ8q__scrollable",
  "smPadding": "Dialog-module__IssQ8q__smPadding",
});
